"use client";

import { useState } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { authClient } from "@/lib/auth-client";

/**
 * `prompt=create` 로 들어와 가입을 마친 뒤, 멈춘 인가 요청을 이어 간다(/oauth2/continue).
 * 서버가 `{ redirect: true, url }` 을 주면 기본 redirect 플러그인이 이동시킨다.
 */
export function ContinueAuthorization({ userLabel }: { userLabel: string }) {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onContinue() {
    setPending(true);
    setError(null);
    const result = await authClient.oauth2.continue({ created: true });
    if (result.error) {
      setPending(false);
      setError(result.error.message || "계속하지 못했습니다. 서비스에서 다시 시도해 주세요.");
    }
  }

  return (
    <div className="space-y-4">
      <p className="text-sm">
        <span className="font-medium">{userLabel}</span> 계정으로 계속합니다.
      </p>
      {error && (
        <Alert variant="destructive">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      <Button className="w-full" onClick={onContinue} disabled={pending}>
        {pending ? "이동 중…" : "계속하기"}
      </Button>
    </div>
  );
}
